import React from 'react';

function Home(props: object) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.75 20.25V14.25H14.25V20.25H20.25V11.25C20.2501 11.1515 20.2307 11.0539 20.1931 10.9629C20.1555 10.8718 20.1003 10.7891 20.0306 10.7194L12.5306 3.21939C12.461 3.14965 12.3783 3.09433 12.2872 3.05659C12.1962 3.01885 12.0986 2.99942 12 2.99942C11.9014 2.99942 11.8038 3.01885 11.7128 3.05659C11.6217 3.09433 11.539 3.14965 11.4694 3.21939L3.96938 10.7194C3.89975 10.7891 3.84454 10.8718 3.8069 10.9629C3.76926 11.0539 3.74992 11.1515 3.75 11.25V20.25H9.75Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Home;
